module.exports = __webpack_public_path__ + "img/1.cb88fb01.jpg";